<template>
    <div class="description p-3 border" v-html="tender.description"></div>
</template>

<script>
export default {
    name: "tender_description",
    props : {
        tender: {
            type: Object,
            required: true
        }
    },
}
</script>


<style scoped>

</style>